import { useState } from 'react';
import { DetailsPanel, EditIcon, IconButton, Typography } from '@weareopenr/component-library';
import { IMenuItem } from 'src/types/menu.types';
import GlobalItemTypeEditModal from '../GlobalItemTypeEditModal/GlobalItemTypeEditModal';
import { capitalise } from 'src/helpers/capitalise';
import { NO_INVENTORY_TYPES } from 'src/constants';

export interface ProductTypePanelProps {
  currentItem: IMenuItem;
}

const isEditable = (type: string) => !NO_INVENTORY_TYPES.includes(type);

const ProductTypePanel = ({ currentItem }: ProductTypePanelProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleModalClick = () => setIsModalOpen((prev: boolean) => !prev);

  return (
    <>
      <GlobalItemTypeEditModal isModalOpen={isModalOpen} onModalClose={handleModalClick} currentItem={currentItem} />
      <DetailsPanel
        title="Product Type"
        action={
          isEditable(currentItem.type) && (
            <IconButton onClick={handleModalClick} aria-label="Edit product type" icon={EditIcon} buttonStyle="ghost" />
          )
        }
      >
        <Typography>{capitalise(currentItem.type)}</Typography>
      </DetailsPanel>
    </>
  );
};

export default ProductTypePanel;
